import { createFileRoute, useLocation } from '@tanstack/react-router'
import { requirePermission } from '@/utils/auth'
import ErrorState from '@/components/Common/ErrorState'
import PageShell from '@/components/Common/PageShell'
import { useTranslation } from 'react-i18next'

type ErrorRouteState = {
  errorMessage: string
}

export const Route = createFileRoute('/scheduling/$startDate/$endDate/error')({
  beforeLoad: () => requirePermission('scheduling'),
  component: ErrorPageComponent,
})

function ErrorPageComponent() {
  const { t } = useTranslation('scheduling')
  const { startDate, endDate } = Route.useParams()
  const location = useLocation()

  const errorMessage = (location.state as unknown as ErrorRouteState | undefined)?.errorMessage || t('anErrorOccurred')

  return (
    <PageShell title={t('error', { ns: 'common' })} fullWidth>
      <ErrorState
        title={t('invalidRoute')}
        message={errorMessage}
        backButtonText={t('backToScheduling')}
        backButtonHref={`/scheduling/${startDate}/${endDate}`}
      />
    </PageShell>
  )
}
